/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Typography } from '@mui/material';

import { Namespaces } from '../../../../i18n';
import { createComponentStyles } from './LoginTagLine.styles';

export const LoginTagLine = memo(() => {
  const { t } = useTranslation(Namespaces.Login);
  const classes = createComponentStyles();
  return (
    <div className={classes.loginSection}>
      <Link to="/">
        <div className={classes.logo} />
      </Link>
      <Typography className={classes.heading} variant="h2">
        {t('page.login.heading')}
      </Typography>
      <Typography className={classes.subheading} variant="body1">
        {t('page.login.subheading')}
      </Typography>
    </div>
  );
});
